import { Model } from "@bryntum/schedulerpro";

export class ClientAgenda extends Model {
  static get $name() {
    return "ClientAgenda";
  }

  static get fields() {
    return [
      { name: "clientId", dataSource: "client" },
      { name: "clientTitle", dataSource: "title" },
      { name: "agendaURL", dataSource: "url" },
      { name: "agendaPassword", dataSource: "password" },
      { name: "isResourceNotesSharingEnabled", dataSource: "is_resource_notes_sharing_enabled" },
      { name: "notes", dataSource: "notes" }
    ];
  }
}

ClientAgenda.exposeProperties();
